const formatPrice = (price, postfix = '') => {
    if (!price) {
        return '';
    }
    let currencySymbol = '₽';
    if (typeof window !== 'undefined' && window.location.hostname.includes('.kz')) {
        currencySymbol = '₸'
    }
    if (typeof window !== 'undefined' && window.location.hostname.includes('.ae')) {
        currencySymbol = 'د.إ'
    }

    const formatted = parseInt(price).toLocaleString('ru-RU', {
        minimumFractionDigits: 0
    });

    return `${formatted} ${currencySymbol}${postfix}`;
}
export default formatPrice;